import firebase from 'firebase/app';
import 'firebase/firestore';
import { firebase_config } from "@/config/config";

if (!firebase.apps.length) {
    firebase.initializeApp(firebase_config);
}
export const app: firebase.app.App = firebase.app();
export const firestore = firebase.firestore;
export const DOCUEMENTID = firebase.firestore.FieldPath.documentId();
export const db = firebase.firestore(app);
export enum FIREBASE_DB_COLLECTION {
    APPLICATION_SETTINGS = "application_settings",
    AUDIT = "audit",
    COMMENTS = "comments",
    DONATIONS = "donations",
    DONATIONS_CONTACT_INFO = "donations_contact_info",
    EMAIL_SETTINGS = "email_settings",
    GROUP_MEMBERS = "group_members",
    GROUPS = "groups",
    GROUPS_PARENTS = "groups_parents",
    MESSAGES = "messages",
    SUPPORT_REQUESTS = "support_requests",
    SUPPORT_REQUESTS_CONTACT_INFO = "support_requests_contact_info",
    USER_PROFILES = "user_profiles",
    VOLUNTEERS = "volunteers",
    VOLUNTEERS_CONTACT_INFO = "volunteers_contact_info"
}